import React, { useEffect, useState } from "react";
import {
  DropdownArrowIcon,
  ErrorText,
  FormContainer,
  FormGroup,
  FormTitle,
  FullWidthContainer,
  Input,
  InputField,
  InputIcon,
  Label,
  NameFieldWrapper,
  NameFieldsContainer,
  PasswordToggle,
  PhonePrefix,
  Select,
} from "../../../styles/PersonalInfoStep";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import {
  LoadingOverlay,
  LoadingSpinner,
  LoadingSpinnerIcon,
} from "../../../styles/loading";
import {
  PasswordValidators,
  PatternValidators,
  TextValidators,
  validPassword,
  validPattern,
  validText,
  validateBirthDate,
} from "../../../utils/validators";
import { setItem, setItemWithObject } from "../../../utils/cache/LocalStorage";
import { GET } from "../../../services/HTTPServices";

import {
  OnBoardingStepProps,
} from "../../../constants";
import City from "../../../assets/svgs/LoginSignup/Step1/city.svg";
import Name from "../../../assets/svgs/LoginSignup/Step1/name.svg";
import Email from "../../../assets/svgs/LoginSignup/Step1/email.svg";
import Mobile from "../../../assets/svgs/LoginSignup/Step1/mobile.svg";
import Password from "../../../assets/svgs/LoginSignup/Step1/password.svg";
import DropdownIcon from "../../../assets/svgs/LoginSignup/Step1/dropdown_icon.svg";
import { StepForm } from "../../../components/signup/StepForm";
const PersonalInfoStep: React.FC<OnBoardingStepProps> = ({
  formData,
  onChange,
  onNext,
  onBack,
  onAssign,
  changedRole,
}) => {

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [submitBtnClick, setSubmitBtnClick] = React.useState(false);

  const [errors, setErrors] = useState<Record<string, boolean>>({
    city: true,
    name: true,
    mobile: true,
    email: true,
    password: true,
    firstName: true,
    lastName: true,
    birthday: true,
    businessType: true,
    hawkerId: true,
  });
  const [loading, setLoading] = React.useState(true);
  const [hawkerCenters, setHawkerCenters] = React.useState([]);

  const [values, setValues] = React.useState({
    id: "", //mobile
    city: "Singapore",
    firstName: "",
    lastName: "",
    name: "",
    mobile: "",
    email: "",
    password: "",
    confirmPassword: "",
    showPassword: false,
    showConfirmPassword: false,
    formValid: true,
    businessType: "personal",
    birthday: "",
    hawkerId: 0,
  });

  // Fix 1: Update the useEffect to respond to formData changes
  useEffect(() => {
    setSubmitBtnClick(false);
    const updateValues = () => {
      if (changedRole) {
        const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
        if (authUser) {
          let path = (authUser.phone ? authUser.phone : authUser.mobile)?.split(
            "+65"
          );
          let mobile = authUser.phone ? path[1] : path[0];

          return {
            city: authUser.userAddress?.city || "Singapore",
            name: authUser.name,
            mobile: mobile,
            email: authUser.email,
            password: "",
            firstName: authUser.firstName,
            lastName: authUser.lastName,
            birthday: authUser.birthday,
            businessType: authUser.businessType,
            hawkerId: authUser.hawkerId,
            confirmPassword: authUser.confirmPassword,
          };
        }
      } else {
        const tempUser = JSON.parse(localStorage.getItem("tempUser") || "null");
        if (tempUser) {
          return {
            city: tempUser.city || "Singapore",
            name: tempUser.name,
            mobile: tempUser.mobile,
            email: tempUser.email,
            password: tempUser.password,
            firstName: tempUser.firstName,
            lastName: tempUser.lastName,
            birthday: tempUser.birthday,
            businessType: tempUser.businessType, // Use formData first
            hawkerId: tempUser.hawkerId, // Use formData first
            confirmPassword: tempUser.confirmPassword,
          };
        }
      }
      return null;
    };

    const newValues = updateValues();
    if (newValues) {
      setValues((prev) => ({
        ...prev,
        ...newValues,
      }));
    }
    setLoading(false);
  }, [changedRole, formData.businessType, formData.hawkerId]); // Add formData dependencies

  // Alternative approach: Initialize values from formData on mount
  useEffect(() => {
    // Initialize from formData if available
    if (
      formData.businessType &&
      formData.businessType !== values.businessType
    ) {
      setValues((prev) => ({
        ...prev,
        businessType: formData.businessType,
      }));
    }

    if (formData.hawkerId && formData.hawkerId !== values.hawkerId) {
      setValues((prev) => ({
        ...prev,
        hawkerId: formData.hawkerId,
      }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.businessType, formData.hawkerId]);

  // Fix 2: Update the change handlers to be synchronous
  const handleChangeType = async (event: any) => {
    const newValue = event.target.value;

    // Update local state immediately
    setValues((prev) => ({
      ...prev,
      businessType: newValue,
    }));

    // Update parent formData
    onChange("businessType", newValue);

    // Update localStorage
    setItem("accounttype", newValue);

    // Validate
    let res = await validateField("businessType", newValue);
    setErrors((prev) => ({
      ...prev,
      businessType: !res,
    }));
  };

  const handleChangeHawkerCenter = async (event: any) => {
    const newValue = event.target.value;

    // Update local state immediately
    setValues((prev) => ({
      ...prev,
      hawkerId: newValue,
    }));

    // Update parent formData
    onChange("hawkerId", newValue);

    // Validate
    let res = await validateField("hawkerId", newValue);
    setErrors((prev) => ({
      ...prev,
      hawkerId: !res,
    }));
  };

  const getHawkerCenter = async () => {
    const res: any = await GET("hawker/GetHawkers", "provider");
    if (res && res.data) {
      setHawkerCenters(res.data);
    }
  };

  useEffect(() => {
    getHawkerCenter();
  }, []);

  const handleCopy = (event: any) => {
    event.preventDefault(); // Prevent default copy behavior
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    onChange(name, value);

    if (name === "firstName" || name === "lastName") {
      const filteredValue = value.replace(/[^a-zA-Z\s]/g, "");
      setValues({ ...values, [name]: filteredValue });
      validateField(name, filteredValue);
    } else {
      setValues({ ...values, [name]: value });
      validateField(name, value);
    }
  };

  const validateField = async (prop: any, value: any) => {
    let isValid: boolean = true;

    try {
      switch (prop) {
        case "city":
        case "name":
        case "firstName":
        case "lastName":
        case "hawkerId":
        case "businessType": {
          isValid = value ? await validText({ text: value, length: 1 }) : false;
          break;
        }
        case "birthday": {
          let res = await validateBirthDate(value);
          isValid = res.valid;
          break;
        }
        case "mobile": {
          isValid = await validPattern({
            paramPattern: value,
            patternType: "mobile",
          });
          break;
        }
        case "email": {
          isValid = await validPattern({
            paramPattern: value,
            patternType: "email",
          });
          break;
        }
        case "password": {
          isValid = await validPassword({ firstPassword: value, length: 8 });
          break;
        }
        case "confirmPassword": {
          isValid = await validPassword({
            firstPassword: values.password,
            secondPassword: value,
            length: 8,
          });
          break;
        }
      }
    } catch (err) {}

    setErrors((prev) => ({
      ...prev,
      [prop]: !isValid, // Invert the error state to match your validation logic
    }));

    return isValid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitBtnClick(true);

    const fieldsToValidate = [
      "city",
      "name",
      "firstName",
      "lastName",
      "mobile",
      "email",
      "businessType",
      "hawkerCenter",
    ];
    if (!changedRole) {
      fieldsToValidate.push("password", "confirmPassword");
    }

    const validationResults = await Promise.all(
      fieldsToValidate.map((field) =>
        validateField(field, values[field as keyof typeof values])
      )
    );

    const hasErrors = validationResults.some((isValid) => !isValid);
    const isFormValid = !hasErrors;

    if (isFormValid && values.confirmPassword && values.confirmPassword?.length > 0) {
      const tempUser = JSON.parse(localStorage.getItem("tempUser") || "null");

      if (tempUser) {
        tempUser.city = values.city;
        tempUser.name = values.name;
        tempUser.firstName = values.firstName;
        tempUser.lastName = values.lastName;
        tempUser.mobile = values.mobile;
        tempUser.email = values.email;
        tempUser.password = values.password;
        tempUser.confirmPassword = values.confirmPassword;

        tempUser.businessType = values.businessType;
        tempUser.hawkerId = values.hawkerId;
        tempUser.birthday = values.birthday;

        setItemWithObject("tempUser", tempUser);
        onNext();
      } else {
        let varUser = {
          firstName: values.firstName,
          lastName: values.lastName,
          name: values.name,
          email: values.email,
          mobile: values.mobile,
          password: values.password,
          confirmPassword: values.confirmPassword,

          idType: "",
          nricFront: [],
          nricFrontPath: [],
          nricBack: [],
          nricBackPath: [],
          letterOfAuth: [],
          letterOfAuthPath: [],
          digitalCopies: [],
          digitalCopiesPath: [],
          storeCover: [],
          storeCoverPath: [],
          catalogue: [],
          cataloguePath: [],
          shopName: "",
          postcode: "",
          city: values.city,
          street: "",
          building: "",
          block: "",
          floor: "",
          unit: "",
          latitude: "",
          longitude: "",
          businessType: values.businessType,
          hawkerId: values.hawkerId,
          entityName: "",
          uen: "",
          signeeName: "",
          signeeNRIC: "",
          createdUserId: "",
          serviceProviderServices: [
            {
              serviceTypeId: 5,
            },
          ],
        };
        setItemWithObject("tempUser", varUser);
        onNext();
      }
    }
  };

  // const handleBack = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   setSubmitBtnClick(true);

  //   const tempUser = JSON.parse(localStorage.getItem("tempUser") || "null");

  //   if (tempUser) {
  //     tempUser.city = values.city;
  //     tempUser.name = values.name;
  //     tempUser.firstName = values.firstName;
  //     tempUser.lastName = values.lastName;
  //     tempUser.mobile = values.mobile;
  //     tempUser.email = values.email;
  //     tempUser.password = values.password;
  //     tempUser.confirmPassword = values.confirmPassword;

  //     tempUser.businessType = values.businessType;
  //     tempUser.hawkerId = values.hawkerId;
  //     tempUser.birthday = values.birthday;

  //     setItemWithObject("tempUser", tempUser);
  //     onBack();
  //   } else {
  //     let varUser = {
  //       firstName: values.firstName,
  //       lastName: values.lastName,
  //       name: values.name,
  //       email: values.email,
  //       mobile: values.mobile,
  //       password: values.password,
  //       confirmPassword: values.confirmPassword,

  //       idType: "",
  //       nricFront: null,
  //       nricFrontPath: [],
  //       nricBack: [],
  //       nricBackPath: [],
  //       letterOfAuth: [],
  //       letterOfAuthPath: [],
  //       digitalCopies: [],
  //       digitalCopiesPath: [],
  //       storeCover: [],
  //       storeCoverPath: [],
  //       catalogue: [],
  //       cataloguePath: [],
  //       shopName: "",
  //       postcode: "",
  //       city: values.city,
  //       street: "",
  //       building: "",
  //       block: "",
  //       floor: "",
  //       unit: "",
  //       latitude: "",
  //       longitude: "",
  //       businessType: values.businessType,
  //       hawkerId: values.hawkerId,
  //       entityName: "",
  //       uen: "",
  //       signeeName: "",
  //       signeeNRIC: "",
  //       createdUserId: "",
  //       serviceProviderServices: [
  //         {
  //           serviceTypeId: 5,
  //         },
  //       ],
  //     };
  //     setItemWithObject("tempUser", varUser);
  //     onBack();
  //   }
  // };

  // Toggle password visibility
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword);

  return (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner>
            <LoadingSpinnerIcon />
          </LoadingSpinner>
        </LoadingOverlay>
      )}
      <FormContainer>
        <FormTitle>Key in your details</FormTitle>
        <StepForm onNext={handleSubmit} onBack={onBack}>
        {/* City Field */}
        <FormGroup $hasError={!!errors.city}>
          <InputIcon>
            <img src={City} alt="City" />
          </InputIcon>
          <FullWidthContainer>
            <Label>City*</Label>
            <InputField $hasError={!!errors.city}>
              <Select
                name="city"
                value={values.city}
                onChange={handleChange}
                $hasError={!!errors.city}
                className="ml-negative-16"
              >
                <option value="">Select your city</option>
                <option value="Singapore">Singapore</option>
                <option value="Kuala Lumpur">Kuala Lumpur</option>
                <option value="Jakarta">Jakarta</option>
                <option value="Bangkok">Bangkok</option>
              </Select>
              <DropdownArrowIcon className="absolute right-0 no-pointer mt-negative-16">
                <img src={DropdownIcon} alt="DropdownIcon" />
              </DropdownArrowIcon>
            </InputField>
          </FullWidthContainer>
        </FormGroup>
        {submitBtnClick && errors.city && (
          <ErrorText>
            <TextValidators text={values.city} textType="City" />
          </ErrorText>
        )}
        {/* Full Name Field */}
        <FormGroup $hasError={!!errors.name}>
          <InputIcon>
            <img src={Name} alt="Name" />
          </InputIcon>
          <FullWidthContainer>
            <Label>Full Name*</Label>
            <InputField $hasError={!!errors.name}>
              <Input
                type="text"
                name="name"
                placeholder="Enter your full name"
                value={values.name}
                onChange={handleChange}
                $hasError={!!errors.name}
                className="ml-negative-16"
              />
            </InputField>
          </FullWidthContainer>
        </FormGroup>
        {submitBtnClick && errors.name && (
          <ErrorText>
            <TextValidators text={values.name} textType="Full Name" />
          </ErrorText>
        )}
        {/* First Name and Last Name Fields */}
        <NameFieldsContainer>
          <NameFieldWrapper>
            <FormGroup $marginBottom="16px" $hasError={!!errors.firstName}>
              <InputIcon>
                <img src={Name} alt="Name" />
              </InputIcon>
              <FullWidthContainer>
                <Label>First Name*</Label>
                <InputField $hasError={!!errors.firstName}>
                  <Input
                    type="text"
                    name="firstName"
                    placeholder="First name"
                    value={values.firstName}
                    onChange={handleChange}
                    $hasError={!!errors.firstName}
                    className="ml-negative-16"
                  />
                </InputField>
              </FullWidthContainer>
            </FormGroup>
            {submitBtnClick && errors.firstName && (
              <ErrorText>
                {" "}
                <TextValidators text={values.firstName} textType="First Name" />
              </ErrorText>
            )}
          </NameFieldWrapper>
          <NameFieldWrapper className="ml-8">
            <FormGroup $marginBottom="16px" $hasError={!!errors.lastName}>
              <InputIcon>
                <img src={Name} alt="Name" />
              </InputIcon>
              <FullWidthContainer>
                <Label>Last Name*</Label>
                <InputField $hasError={!!errors.lastName}>
                  <Input
                    type="text"
                    name="lastName"
                    placeholder="Last name"
                    value={values.lastName}
                    onChange={handleChange}
                    $hasError={!!errors.lastName}
                    className="ml-negative-16"
                  />
                </InputField>
              </FullWidthContainer>
            </FormGroup>
            {submitBtnClick && errors.lastName && (
              <ErrorText>
                {" "}
                <TextValidators text={values.lastName} textType="Last Name" />
              </ErrorText>
            )}
          </NameFieldWrapper>
        </NameFieldsContainer>

        {/* Mobile Number Field */}
        <FormGroup $hasError={!!errors.mobile}>
          <InputIcon>
            <img src={Mobile} alt="Mobile" />
          </InputIcon>
          <FullWidthContainer>
            <Label>Mobile*</Label>
            <InputField $hasError={!!errors.mobile}>
              <PhonePrefix>+65</PhonePrefix>
              <Input
                type="number"
                name="mobile"
                placeholder="Enter mobile number"
                value={values.mobile}
                onChange={handleChange}
                $hasError={!!errors.mobile}
                className="ml-16"
              />
            </InputField>
          </FullWidthContainer>
        </FormGroup>
        {submitBtnClick && errors.mobile && (
          <ErrorText>
            <PatternValidators
              paramPattern={values.mobile}
              patternType="mobile"
              textType="Mobile"
            />
          </ErrorText>
        )}
        {/* Email Field */}
        <FormGroup $hasError={!!errors.email}>
          <InputIcon>
            <img src={Email} alt="Email" />
          </InputIcon>
          <FullWidthContainer>
            <Label>Email*</Label>
            <InputField $hasError={!!errors.email}>
              <Input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={values.email}
                onChange={handleChange}
                $hasError={!!errors.email}
                className="ml-negative-16"
                autoComplete="new-email"
              />
            </InputField>
          </FullWidthContainer>
        </FormGroup>
        {submitBtnClick && errors.email && (
          <ErrorText>
            <PatternValidators
              paramPattern={values.email}
              patternType="email"
              textType="Email"
            />
          </ErrorText>
        )}

        <FormGroup $hasError={!!errors.businessType}>
          <FullWidthContainer>
            <Label>Business Type*</Label>
            <InputField $hasError={!!errors.businessType}>
              <Select
                name="businessType"
                value={values.businessType}
                onChange={handleChangeType}
                $hasError={!!errors.city}
                className="ml-negative-16"
              >
                <option value="">Select your business type</option>
                <option value="personal">Personal</option>
                <option value="business">Business</option>
              </Select>
              <DropdownArrowIcon className="absolute right-0 no-pointer mt-negative-16 cursor-pointer">
                <img src={DropdownIcon} alt="DropdownIcon" />
              </DropdownArrowIcon>
            </InputField>
          </FullWidthContainer>
        </FormGroup>
        {submitBtnClick && errors.businessType && (
          <ErrorText>
            {" "}
            <TextValidators
              text={values.businessType}
              textType="Business Type"
            />
          </ErrorText>
        )}

        <FormGroup $hasError={!!errors.hawkerId}>
          <FullWidthContainer>
            <Label>Hawker Center*</Label>
            <InputField $hasError={!!errors.hawkerId}>
              <Select
                name="hawkerId"
                value={values.hawkerId}
                onChange={handleChangeHawkerCenter}
                $hasError={!!errors.hawkerId}
                className="ml-negative-16"
              >
                <option value="">Select your hawker center</option>

                {hawkerCenters?.map((center: any) => (
                  <option key={center.id} value={center.id}>
                    {center.name}
                  </option>
                ))}
              </Select>

              <DropdownArrowIcon className="absolute right-0 no-pointer mt-negative-16">
                <img src={DropdownIcon} alt="DropdownIcon" />
              </DropdownArrowIcon>
            </InputField>
          </FullWidthContainer>
        </FormGroup>
        {submitBtnClick && errors.hawkerId && (
          <ErrorText>
            {" "}
            <TextValidators text={values.hawkerId} textType="Hawker Center" />
          </ErrorText>
        )}

        {!changedRole && (
          <>
            {/* Password Field */}
            <FormGroup $hasError={!!errors.password}>
              <InputIcon>
                <img src={Password} alt="Password" />
              </InputIcon>
              <FullWidthContainer>
                <Label>Password</Label>
                <InputField $hasError={!!errors.password}>
                  <Input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Create a password"
                    value={values.password}
                    onChange={handleChange}
                    // onCopy={handleCopy}
                    // onPaste={handleCopy}
                    $hasError={!!errors.password}
                    className="ml-negative-16"
                    autoComplete="new-password"
                  />
                  <PasswordToggle
                    onClick={togglePasswordVisibility}
                    type="button"
                    className="mt-negative-24"
                  >
                    {showPassword ? (
                      <VisibilityOff className="text-warning" />
                    ) : (
                      <Visibility className="text-warning" />
                    )}
                  </PasswordToggle>
                </InputField>
              </FullWidthContainer>
            </FormGroup>
            {submitBtnClick && errors.password && (
              <ErrorText>
                <PasswordValidators
                  firstPassword={values.password}
                  length={8}
                />
              </ErrorText>
            )}
            {/* Confirm Password Field */}
            <FormGroup $hasError={!!errors.confirmPassword}>
              <InputIcon>
                <img src={Password} alt="Password" />
              </InputIcon>
              <FullWidthContainer>
                <Label>Confirm your Password</Label>
                <InputField $hasError={!!errors.confirmPassword}>
                  <Input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Confirm your password"
                    value={values.confirmPassword}
                    onChange={handleChange}
                    onCopy={handleCopy}
                    onPaste={handleCopy}
                    $hasError={!!errors.confirmPassword}
                    className="ml-negative-16"
                    autoComplete="new-password"
                  />
                  <PasswordToggle
                    onClick={toggleConfirmPasswordVisibility}
                    type="button"
                    className="mt-negative-24"
                  >
                    {showConfirmPassword ? (
                      <VisibilityOff className="text-warning" />
                    ) : (
                      <Visibility className="text-warning" />
                    )}
                  </PasswordToggle>
                </InputField>
              </FullWidthContainer>
            </FormGroup>
            {submitBtnClick && (
              <ErrorText>
                {values.confirmPassword && values.confirmPassword?.length > 0 ? 
                (
                  <PasswordValidators
                  firstPassword={values.password}
                  secondPassword={values.confirmPassword}
                  length={8}
                />
                ) : (
                  <span>Confirm Password is required.</span>
                )}
                
              </ErrorText>
            )}
          </>
        )}
        
        </StepForm>
      </FormContainer>
    </>
  );
};

export default PersonalInfoStep;
